import { StreamActions } from '@hotwired/turbo'
import { disabledButtons } from '/libs/kisses'

// Disables the buttons of the Rails cards and announces the kiss to the Vue user list, which keeps the
// state of its cards in a store: they are recycled by the virtual scroller and carry no button ids.
StreamActions.kiss_sent = function() {
  const userId = Number(this.getAttribute('user-id'))
  const type = this.getAttribute('type')

  disabledButtons(type).forEach((button) => {
    document.querySelectorAll(`#bt-${button.replaceAll('_', '-')}-${userId}`).forEach((e) => e.setAttribute('disabled', 'disabled'))
  })

  window.dispatchEvent(new CustomEvent('kiss:sent', { detail: { userId, type } }))
}
